import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Zap, ArrowUpRight, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Identifiants invalides");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background" data-testid="admin-login-page">
      <div className="hidden md:flex bg-graphite text-white relative grain overflow-hidden">
        <div className="m-auto p-16 max-w-md">
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white overline tech-link mb-12" data-testid="login-back-home">
            <ArrowLeft size={14} /> Retour au site
          </Link>
          <div className="flex items-center gap-3 mb-10">
            <div className="w-11 h-11 border border-white/30 flex items-center justify-center">
              <Zap size={20} className="copper" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display font-bold text-xl">AMINE-ELEC</div>
              <div className="overline text-white/60 -mt-0.5">Espace Pro</div>
            </div>
          </div>
          <h1 className="font-display font-black text-4xl tracking-tighter leading-[1.0]">
            Pilotez vos<br/>demandes de devis<br/>en temps réel.
          </h1>
          <p className="mt-6 text-white/70 leading-relaxed">
            Accès réservé à l'équipe ÉlectroPro. Suivi des demandes entrantes, statuts et archives.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="overline copper mb-3">Connexion · administration</div>
          <h2 className="font-display font-bold text-3xl md:text-4xl tracking-tight">Identifiez-vous</h2>
          <p className="text-muted-foreground mt-2">Réservé aux administrateurs autorisés.</p>

          <div className="mt-10 space-y-5">
            <label className="block">
              <span className="overline text-foreground/70 block mb-2">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="admin@amine-elec.fr"
                className="ep-input w-full px-4 py-3 border border-border bg-white focus:outline-none focus:border-copper focus:ring-1 focus:ring-copper"
                style={{ borderRadius: 2 }}
                data-testid="login-input-email"
              />
            </label>
            <label className="block">
              <span className="overline text-foreground/70 block mb-2">Mot de passe</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="ep-input w-full px-4 py-3 border border-border bg-white focus:outline-none focus:border-copper focus:ring-1 focus:ring-copper"
                style={{ borderRadius: 2 }}
                data-testid="login-input-password"
              />
            </label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-copper mt-8 w-full justify-center disabled:opacity-50"
            data-testid="login-submit"
          >
            {loading ? "Connexion…" : "Se connecter"}
            <ArrowUpRight size={18} strokeWidth={2.5} />
          </button>

          <Link to="/" className="mt-6 inline-flex items-center gap-2 overline text-muted-foreground hover:text-foreground md:hidden tech-link" data-testid="login-back-home-mobile">
            <ArrowLeft size={14} /> Retour au site
          </Link>
        </form>
      </div>
    </div>
  );
}
